export function testKey(key, str) {
    return str.charCodeAt(0) === key || str.toUpperCase().charCodeAt(0) === key;
}
